module.exports = __webpack_public_path__ + "img/la.4445bda3.svg";